import directives from './module';
import SpinnerSvc from 'services/SpinnerSvc';
import {AnimatronProjectsFactory} from '../services/AnimatronProjectsSvc';
import {AnimatronProjects} from '../services/AnimatronProjectsSvc';
import {AdSvc} from 'services/AdSvc';
import {TranslateSvc} from '../services/TranslateSvc';

export class ExploreCtrl implements ng.IComponentController {
    private static DefMinVersion = 100;
    private static CdnUrl = 'https://d36bq5zmf7yjgb.cloudfront.net';

    tabs: Array<anm.ExploreTabs>;
    trackerFunction: (eventObject: JQueryEventObject) => any;
    currentTab: anm.ExploreTabs;
    contestType = 'USER';
    isStaffPicks: boolean;

    private TabParams: {[tab: string]: ProjectSearchCriteria} = {
        'most-plays': {
            sortBy: 'views',
            minViews: 1,
            minVersion: ExploreCtrl.DefMinVersion,
            noCount: true
        },
        'staff-picks': {
            sortBy: 'tag_creation_time',
            tag: 'Staff Picks',
            tag_type: 'SUPER',
            minVersion: ExploreCtrl.DefMinVersion,
            noCount: true
        },
        'contest-submissions': {
            sortBy: 'tag_creation_time',
            tag_type: 'CONTEST',
            minVersion: 0,
            contestType: this.contestType //TODO should be changed
        },
        'recently-added': {
            minVersion: ExploreCtrl.DefMinVersion,
            noCount: true
        },
        'my-projects': {}
    };

    tabsConfig = {
        'my-projects': options.user.anonymous,
        'contest-submissions': !options.enableContests
    };

    constructor(private $scope: any,
                private $state: ng.ui.IStateService,
                private $rootScope: ng.IRootScopeService,
                private $location: ng.ILocationService,
                private AnimatronProjects: AnimatronProjectsFactory,
                private TranslateSvc: TranslateSvc) {

        this.trackerFunction = angular.noop;

        $scope.$on('$destroy', () => {
            angular.element(window).unbind('scroll', this.trackerFunction);
        });

        $scope.$watch(() => this.contestType, () => this.contestType && this.onTabChange(this.currentTab));

        if ($location.search().confirmationSent) {
            _.notification.showSuccess(TranslateSvc.get('profile.confirmation-sent'));
            $location.url($location.path()).replace();
        }
        if ($location.search().login) {
            $location.url($location.path()).replace();
        }
    }

    onTabChange(currentHash: anm.ExploreTabs) {
        if (!currentHash) return;
        if (!this.tabs.includes(currentHash)) currentHash = 'staff-picks';
        this.currentTab = currentHash;
        this.isStaffPicks = currentHash === 'staff-picks';
        this.$scope.animatron = this.getNewProjectService(currentHash);
        this.$scope.animatron.nextPage().then(() => SpinnerSvc.hide());
    };

    getNewProjectService(currentTab: anm.ExploreTabs): AnimatronProjects {
        const ownProjects = currentTab === 'my-projects';
        this.$scope.AdSvc = new AdSvc(!ownProjects, this.$rootScope);
        const tabParams   = this.TabParams[currentTab];
        if (!tabParams) {
            throw new Error(`cannot find svc params for tab - '${currentTab}'`);
        }
        if (this.$state.params.product && options.user.features.Admin) {
            tabParams.product = this.$state.params.product;
            tabParams.minVersion = 0;
        }
        return new this.AnimatronProjects(
            Object.assign({}, tabParams),
            ownProjects,
            this.cdnUrlCondition() ? ExploreCtrl.CdnUrl : '',
            this.$scope.AdSvc.adify.bind(this.$scope.AdSvc)
        );
    }

    private cdnUrlCondition() {
        return options.isProduction && this.isStaffPicks && !options.user.features.Admin;
    }

}

directives.component('explorePage', {
    controllerAs: 'ExploreCtrl',
    controller: ExploreCtrl,
    templateUrl: require('explore.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/ExplorePage.ts